$(document).ready(function(){
	$('ul.tabs li').click(function(){
      $('.tabs li').removeClass('current');
      $(this).addClass('current');
		var tab_id = $(this).attr('data-tab');
		// $('ul.tabs li').removeClass('current');
		$('.tab-content').removeClass('current');
		$(this).parents('.tabs_main').find("#"+tab_id).addClass('current');
	});
 $('.acc-head').click(function(){
    $(this).next().slideToggle(800);
    $(this).toggleClass('active');
  });
});
